import React from 'react';
import classnames from 'classnames';
import { noop, isEmpty, get, defaultTo, isEqual, isNil, trimStart, isFunction } from 'lodash';
import InputMask from 'react-input-mask';

// local dependencies
import { getLabel } from 'utils/getLabel';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { inputField as InputField } from 'ui/views/generic/inputField';
 *
 * // render
 * <InputField propName='propValue'/>
 */
export const inputField = ( props ) => {

    // get error message (ref)
    const errorMessage = get( props.error, 'message', null );
    const hasError = ! isEmpty( errorMessage );

    // dynamic class name
    const widgetClassName = classnames( 'ui-input-field', props.className, {
        'ui-input-field--error': hasError,
    } );

    const inputClassName = classnames( 'ui-input-field__editable__input__element', {
        'ui-input-field__editable__input__element--disabled': props.disabled || get( props, 'config.readonly', false ),
        'ui-input-field__editable__input__element--has-prefix': ! isEmpty( props.prefix ),
        'ui-input-field__editable__input__element--search-prefix': props.searchPrefix
    } );

    const inputPrefixClassName = classnames( 'ui-input-field__editable__input__prefix', {
        'ui-input-field__editable__input__prefix--search-prefix': props.searchPrefix
    } );

    return (
        <div className={ widgetClassName }>

            {/* if mode is readonly  */}
            { isEqual( props.mode, 'readonly' ) ? (
                <div className='ui-input-field__readonly'>
                    
                    {/* label */}
                    <div className='ui-input-field__readonly__label'>
                        { getLabel( props.label ) }
                    </div>

                    {/* input */}
                    <div className='ui-input-field__readonly__text'>
                        { defaultTo( props.value, '' ) }
                    </div>
                </div>
            ) : (
    
                // if mode is not readonly
                <div className='ui-input-field__editable'>
                    {/* label */}
                    {
                        props.showLabel ? (
                            <div className='ui-input-field__editable__label'>
                                {/* label text */}
                                <div className='ui-input-field__editable__label__text'>{ getLabel( props.label ) }</div>

                                {/* required asterisk */}
                                {
                                    props.required ? (
                                        <div className='ui-input-field__editable__label__asterisk'>*</div>
                                    ) : null
                                }

                                {
                                    ! isNil( props.maxLength ) ? (
                                        <div className='ui-input-field__editable__label__remaining'>Remaining: { props.maxLength - defaultTo( props.value, '' ).length }</div>
                                    ) : null
                                }

                            </div>
                        ) : null
                    }


                    {/* input */}
                    <div className={ 'ui-input-field__editable__input' }>

                        {/* prefix */}
                        {
                            ! isEmpty( props.prefix ) ? (
                                <div className={ inputPrefixClassName }>{ props.prefix }</div>
                            ) : null
                        }

                        <InputMask
                            type='text'
                            className={ inputClassName }
                            placeholder={ ! isEmpty( props.placeholder ) ? getLabel( props.placeholder ) : '' }
                            value={ defaultTo( props.value, '' ) }
                            
                            // required={ props.required }
                            mask={ props.mask }
                            maxLength= { props.maxLength }
                            onKeyDown = { ( event ) => {
                                isFunction( props.onKeyDown ) ? props.onKeyDown( event ) : noop;
                            } }
                            readOnly = { props.disabled || get( props, 'config.readonly', false ) }
                            onChange={ ( event ) => {
                                props.onChange( {
                                name: props.name,
                                value: trimStart(event.target.value ),
                            } )} }
                        />
                    </div>
                </div>
            ) }

            {/* error message */}
            {
                hasError && ! isEqual( props.mode, 'readonly' ) ? (
                    <div className='ui-input-field__error'>
                        <div className='ui-input-field__error__message'>
                            { getLabel( errorMessage ) }
                        </div>
                    </div>
                ) : null
            }
        </div>
    );
};

// set display name
inputField.displayName = 'inputField';

// set default props
inputField.defaultProps = {
    name: null,
    label: null,
    placeholder: null,
    disabled: false,
    value: '',
    onChange: noop,
    required: false,
    error: {},
    mode: null, // possible values `null`, `readonly`.
    mask: undefined,
    showLabel: true,
    prefix: null,
    onKeyDown: null
};

// prop types
inputField.propTypes = {};
